import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IFormItemsControls} from '../../../../interface/form-structure';
import {IFiles} from '../../ViewItems/viewfiles/viewfiles.component';
import {FormItemComponentInterface} from '../../../../interface/component';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {IHttpSetting} from '../../../../interface/dataset-params';
import {HttpFormDataService} from '../../../../services/services';
import {GlobalObjectService} from '../../../../class/global-obj';
import * as moment_ from 'moment';

const moment = moment_;

@Component({
    selector: 'noos-vertical-bar',
    templateUrl: './vertical-bar.component.html',
    styleUrls: ['./vertical-bar.component.scss']
})
@NoosFormTypeService.register('vbar')
export class VerticalBarComponent implements OnInit, AfterViewInit, FormItemComponentInterface {

    prop: IFormItemsControls;
    isFilter = false;

    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    recordId: 0;

    fileList: IFiles[] = [];


    settings =
        {
            roundEdges: true,
            yScaleMin: '',
            yScaleMax: '',
            tooltipDisabled: false,
            barPadding: 8,
            gradient: false,
            noBarWhenZero: true,
            showDataLabel: false,
            maxYAxisTickLength: 16,
            maxXAxisTickLength: 16,
            rotateXAxisTicks: true,
            trimYAxisTicks: true,
            trimXAxisTicks: true,
            yAxisLabel: '',
            xAxisLabel: '',
            showYAxisLabel: false,
            showXAxisLabel: false,
            roundDomains: false,
            showGridLines: true,
            xAxis: false,
            yAxis: false,
            legend: true,
            legendTitle: '',
            legendPosition: 'right',
            colorScheme: [],
            view: [300, 300],
            animations: true,
            fitInContainer: false,
        };

    colorScheme = {
        domain: ['#F72585', '#7209B7', '#3A0CA3', '#4361EE', '#4CC9F0']
    };

    view = [300, 300];

    uid = '';


    data = [];
    setting: IHttpSetting;
    locale = 'tr';
    footerInfo = '...';

    constructor(private httpService: HttpFormDataService) {
        this.setting = GlobalObjectService.getVar('setting');
        this.locale = this.setting.env[0].locale;
    }

    ngOnInit() {
        Object.assign(this, this.prop.options);
        if (this.settings && this.settings.colorScheme && this.settings.colorScheme.length > 0) {
            this.colorScheme.domain = this.settings.colorScheme;
        }
        if (this.settings && this.settings.view && this.settings.view.length > 0) {
            this.view = this.settings.view;
        }
        if (this.settings && this.settings.fitInContainer) {
            this.view = null;
        }

    }

    loadKPI(noCache = false) {
        this.httpService.dashboard_kpi(this.setting, this.uid, noCache).subscribe(ret => {
            if (ret.complete) {
                this.data = ret.data;
                moment.locale(this.locale);
                this.footerInfo = moment(new Date()).add(-1 * ret.diff, 'minutes').startOf('minute').fromNow();
            }
        });
    }

    ngAfterViewInit(): void {
        this.loadKPI();
    }

}
